import { ContainerModule } from 'inversify';
import type { IHttpService } from './HttpService';
import { HttpService } from './HttpService';

import { TYPES } from './iocTypes';

export const httpModule = new ContainerModule((bind) => {
  bind<IHttpService>(TYPES.HttpService).to(HttpService).inSingletonScope();
});
